import SmallTitle from "../../components/shared/SmallTitle";
import Title from "../../components/shared/Title";
import Description from "../../components/shared/Description";
import "./ContactUs.scss";
import ContactUsCard from "./components/ContactUsCard";

import ContactUsTelegramImg from "../../assets/images/contact-us-telegram.png";
import ContactUsGitBookImg from "../../assets/images/contact-us-gitbook.png";
import ContactUsTwitterImg from "../../assets/images/contact-us-twitter.png";
import { ArrowRight } from "iconsax-react";

import DesktopOval2 from "../../assets/images/decoration/desktop-oval-2.svg";
import DesktopOval3 from "../../assets/images/decoration/desktop-oval-3.svg";
import ContactUsSharpLightsDesktop from "../../assets/images/decoration/contact-us-sharp-lights-desktop.svg";

export default function ContactUs() {
	return (
		<>
			<div className="contact-us" id="contact-us">
				<img
					className="decoration sharp-lights"
					src={ContactUsSharpLightsDesktop}
					alt="decorative-img"
				/>

				<div className="contact-us-content-wrapper content-wrapper-lg">
					<img
						className="decoration light desktop-light-1"
						src={DesktopOval3}
						alt="decorative-img"
					/>
					<img
						className="decoration light desktop-light-2"
						src={DesktopOval2}
						alt="decorative-img"
					/>
					<img
						className="decoration light desktop-light-3"
						src={DesktopOval2}
						alt="decorative-img"
					/>
					<div className="contact-us-content">
						<SmallTitle className="contact-us-small-title" data-aos="fade-up">
							Stay Connected Across Platforms!
						</SmallTitle>

						<Title className="contact-us-title" data-aos="fade-up" data-aos-delay="100">
							Your Gateway to Real-Time Updates and Resources
						</Title>

						<Description className="contact-us-desc" data-aos="fade-up" data-aos-delay="200">
							Stay ahead with instant updates and direct access to
							crucial information across Telegram, GitBook, and
							Twitter. Engage with a community of crypto
							enthusiasts.
						</Description>
					</div>

					<ul className="contact-us-list">
						<li className="contact-us-item" data-aos="zoom-in">
							<ContactUsCard
								className="contact-us-card-1"
								style={{ "--light-color": "#0091C8" }}
							>
								<div className="contact-us-card-head">
									<img
										src={ContactUsTelegramImg}
										alt="Telegram"
									/>
								</div>

								<div className="contact-us-card-body">
									<div className="contact-us-card-title">
										Join Us on Telegram!
									</div>

									<div className="contact-us-card-desc">
										Connect with enthusiasts, get insider
										updates, and be the first to know about
										exciting opportunities in our Telegram
										group.
									</div>

									<div className="contact-us-card-join">
										Join Telegram
										<ArrowRight
											className="join-icon"
											size={24}
											color="#0091C8"
										/>
									</div>
								</div>
							</ContactUsCard>
						</li>
						<li className="contact-us-item" data-aos="zoom-in" data-aos-delay="100">
							<ContactUsCard
								className="contact-us-card-2"
								style={{ "--light-color": "#346DDB" }}
								href="https://chain-compute-ai-organization.gitbook.io/chaincompute-ai"
							>
								<div className="contact-us-card-head">
									<img
										src={ContactUsGitBookImg}
										alt="GitBook"
									/>
								</div>

								<div className="contact-us-card-body">
									<div className="contact-us-card-title">
										Join Us on Gitbook
									</div>

									<div className="contact-us-card-desc">
										Explore detailed documentation, connect
										with like-minded enthusiastsd with the
										latest insights. Be part of a growing
										community shaping the future!
									</div>

									<div className="contact-us-card-join">
										Join Gitbook
										<ArrowRight
											className="join-icon"
											size={24}
											color="#4D2A7E"
										/>
									</div>
								</div>
							</ContactUsCard>
						</li>
						
						<li className="contact-us-item" data-aos="zoom-in" data-aos-delay="200">
							<ContactUsCard
								className="contact-us-card-3"
								style={{ "--light-color": "#B0B0B0" }}
								href="https://x.com/ChainComputeAI"
							>
								<div className="contact-us-card-head">
									<img
										src={ContactUsTwitterImg}
										alt="Twitter"
									/>
								</div>

								<div className="contact-us-card-body">
									<div className="contact-us-card-title">
										Join the Conversation on Twitter!
									</div>

									<div className="contact-us-card-desc">
										Connect with enthusiasts, get real-time
										updates, and be the first to discover
										exciting opportunities in the crypto
										space. Follow us to stay in the loop!.
									</div>

									<div className="contact-us-card-join">
										Join Twitter
										<ArrowRight
											className="join-icon"
											size={24}
											color="#B0B0B0"
										/>
									</div>
								</div>
							</ContactUsCard>
						</li>
					</ul>
				</div>
			</div>
		</>
	);
}
